import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { pathgen } from 'object-path-generator';
import { Box, CloseButton, Typography } from 'seagull';
import { useLocaleKeys } from '~/i18n';
import { BulkInvoiceDetails } from './BulkInvoiceDetails/BulkInvoiceDetails';
import styles from './FileDetails.module.scss';
const bulkBillingTextsPath = 'billing.hub.bulkBilling';
export const getItemsCount = (lines, invoicesCount, texts)=>{
    return texts.lineItemsInInvoices({
        lines,
        invoicesCount
    });
};
export const FileDetailsTestIds = pathgen('FileDetailsTestIds');
export const FileDetails = (param)=>{
    let { name, lines, invoicesCount, invoices, onRemove } = param;
    const { t: bulkBillingTexts } = useLocaleKeys(bulkBillingTextsPath);
    return /*#__PURE__*/ _jsxs(Box, {
        className: styles.fileDetailsWrapper,
        children: [
            /*#__PURE__*/ _jsxs(Box, {
                className: styles.fileDetails,
                testId: FileDetailsTestIds.Container(),
                children: [
                    /*#__PURE__*/ _jsxs(Box, {
                        className: styles.fileDetailsText,
                        children: [
                            /*#__PURE__*/ _jsx(Typography, {
                                testId: FileDetailsTestIds.Name(),
                                children: name
                            }),
                            lines && invoicesCount && /*#__PURE__*/ _jsxs(Typography, {
                                testId: FileDetailsTestIds.FileSummaryInfo(),
                                skin: "secondary",
                                children: [
                                    "(",
                                    getItemsCount(lines, invoicesCount, bulkBillingTexts),
                                    ")"
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx(CloseButton, {
                        bi: {
                            name: 'remove_bulk_billing_file'
                        },
                        size: "small",
                        onClick: onRemove,
                        testId: FileDetailsTestIds.RemoveFileButton()
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(BulkInvoiceDetails, {
                invoices: invoices !== null && invoices !== void 0 ? invoices : []
            })
        ]
    });
};
